module.exports = "https://www.gc-pro.gnp.com.mx/5ec4a4116e0c3fc11a3972db4e2837cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle.svg
// module id = 8087
// module chunks = 0